// =============================================================================
// MessageComposer/audioFileExtension.ts — Extensão do arquivo de áudio gravado
// a partir do MIME do MediaRecorder (F51-S41).
//
// Por que importa: o backend monta a key do storage com a extensão do nome do
// arquivo, e o pipeline de envio usa mime E extensão da URL para escolher o
// demuxer do ffmpeg (`audioSourceFormat.ts`). Antes, tudo que não era ogg virava
// `.webm` — o Safari/iPhone grava `audio/mp4`, subia como `.webm`, o ffmpeg
// tentava ler mp4 com o demuxer de webm e a mensagem falhava.
//
// Puro (sem DOM) — testável sem renderizar React.
// =============================================================================

/** Extensão (sem ponto) por subtipo de áudio. Fora da tabela → `bin`. */
const SUBTYPE_TO_EXTENSION: Readonly<Record<string, string>> = {
  webm: 'webm',
  ogg: 'ogg',
  opus: 'ogg',
  mp4: 'm4a',
  'x-m4a': 'm4a',
  m4a: 'm4a',
  aac: 'aac',
  mpeg: 'mp3',
  mp3: 'mp3',
};

/**
 * `audio/mp4;codecs=mp4a.40.2` → `m4a`; `audio/webm;codecs=opus` → `webm`;
 * `audio/ogg;codecs=opus` → `ogg`.
 *
 * MIME desconhecido → `bin`: o backend não reconhece o formato e não chama o
 * ffmpeg com um demuxer errado (falha fechada). Nunca chuta `webm`.
 */
export function audioFileExtension(mime: string): string {
  const base = mime.split(';')[0]?.trim().toLowerCase() ?? '';
  const [type, subtype] = base.split('/');
  if (type !== 'audio' || subtype === undefined) return 'bin';
  return SUBTYPE_TO_EXTENSION[subtype] ?? 'bin';
}
